import { Skeleton } from "@heroui/react"
import { EmptyCard } from "./Card"

export const SkeletonCard = () => {
  return (
    <EmptyCard>
      <Skeleton className="rounded-lg">
        <div className="w-full aspect-square"></div>
      </Skeleton>
      <div className="space-y-3 mt-[20px]">
        <Skeleton className="w-3/5 rounded-lg">
          <div className="h-3 w-3/5 rounded-lg bg-default-200"></div>
        </Skeleton>
        <Skeleton className="w-4/5 rounded-lg">
          <div className="h-3 w-4/5 rounded-lg bg-default-200"></div>
        </Skeleton>
        <Skeleton className="w-2/5 rounded-lg">
          <div className="h-3 w-2/5 rounded-lg bg-default-300"></div>
        </Skeleton>
        <Skeleton className="w-full rounded-lg">
          <div className="h-3"></div>
        </Skeleton>
      </div>
    </EmptyCard>
  )
}